import {
  LOAD_SONG_ANNOTATIONS,
  UNLOAD_CURRENT_ARTIST,
  UNLOAD_CURRENT_SONG,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const annotations = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
    case UNLOAD_CURRENT_SONG:
      return null;

    case LOAD_SONG_ANNOTATIONS:
      return loadReducer(state, action);
    default:
      return state;
  }
};
